import QR from "react-qr-code";
import React, { useMemo } from "react";

export const QRCode = ({ value = "QR Code", size }) => {
  return <QR value={value} size={size} />;
};
